// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.click-to-add-logo[data-v-21f48066]{\n  font-size: 14px;cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
